import React, { useState, useEffect } from "react";
import ImagePostModalStyles from "./ImagePostModalStyles.module.css";
import { useImagePostModal } from "../../context/ImagePostModalContext";

const ImagePostModal = () => {
  const { closeModal, data } = useImagePostModal();
  const images = data?.imageURL || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Jump to the tapped image whenever the modal opens with new data
  useEffect(() => {
    setCurrentIndex(data?.initialIndex ?? 0);
  }, [data]);

  const showPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const showNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div
      className={ImagePostModalStyles.imagePostModalContainer}
      style={data ? { overflowY: "scroll" } : {}}
    >
      <div className={ImagePostModalStyles.imagePostModalMain}>
        <div className={ImagePostModalStyles.imagePostModalMainContent}>
          <button
            onClick={closeModal}
            aria-label="Close modal"
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <i className="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
          <div className={ImagePostModalStyles.imagePostModalMainBlk}>
            {images.length > 0 && (
              <img
                src={images[currentIndex]}
                alt={`Post ${currentIndex + 1}`}
                className={ImagePostModalStyles.imagePostModalImage}
              />
            )}

            {images.length > 1 && (
              <>
                <button
                  className={ImagePostModalStyles.leftArrow}
                  onClick={showPrev}
                  aria-label="Previous image"
                >
                  <i
                    className="fa-solid fa-chevron-left"
                    aria-hidden="true"
                  ></i>
                </button>

                <button
                  className={ImagePostModalStyles.rightArrow}
                  onClick={showNext}
                  aria-label="Next image"
                >
                  <i
                    className="fa-solid fa-chevron-right"
                    aria-hidden="true"
                  ></i>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePostModal;
